// extracted by mini-css-extract-plugin
export default {"button":"Button_button__kse41","danger":"Button_danger__2QALr","empty":"Button_empty__IuJf0"};